export enum LineType {
  Dots = 'dots',
  Solid = 'solid',
  Squares = 'squares',
}
